import { DiCss3, DiHtml5 } from 'react-icons/di';
import {
  SiJavascript,
  SiTypescript,
  SiNextdotjs,
  SiReact,
} from 'react-icons/si';

export const skills = [
  {
    name: 'CSS',
    logo: <DiCss3 />,
    percent: 70,
  },
  {
    name: 'HTML',
    logo: <DiHtml5 />,
    percent: 80,
  },
  {
    name: 'JS',
    logo: <SiJavascript />,
    percent: 70,
  },
  {
    name: 'TS',
    logo: <SiTypescript />,
    percent: 30,
  },
];

export const frameworks = [
  {
    name: 'REACT',
    logo: <SiReact />,
    percent: 70,
  },
  {
    name: 'NEXT JS',
    logo: <SiNextdotjs />,
    percent: 40,
  },
];
